import {
  Component,
  EventEmitter,
  Output,
  OnInit,
  OnDestroy,
} from '@angular/core';

import { FormsModule } from '@angular/forms';
import { Subject, debounceTime, distinctUntilChanged } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-table-search',
  standalone: true,
  imports: [FormsModule, TranslateModule],
  templateUrl: './table-search.component.html',
  styleUrl: './table-search.component.scss',
})
export class TableSearchComponent implements OnInit, OnDestroy {
  @Output() searchChange = new EventEmitter<string>();

  searchText: string = '';
  private searchSubject = new Subject<string>();
  private destroy$ = new Subject<void>();

  ngOnInit() {
    this.setupSearchDebounce();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private setupSearchDebounce() {
    this.searchSubject
      .pipe(debounceTime(300), distinctUntilChanged()) //Debounced input to prevent excessive API calls
      .subscribe((searchText) => {
        this.searchChange.emit(searchText);
      });
  }

  onSearchChange(searchText: string) {
    this.searchSubject.next(searchText);
  }

  clearSearch() {
    this.searchText = '';
    this.searchChange.emit('');
  }
}
